import { render, staticRenderFns } from "./statsComponent.vue?vue&type=template&id=0945a709"
import script from "./statsComponent.vue?vue&type=script&lang=js"
export * from "./statsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports